import { customCell } from '@components/table/customCell';
import { BodyText, TableCellProps } from '@servicetitan/design-system';
import { FC } from 'react';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import { Text } from '@servicetitan/anvil2';
import {
  DYNAMIC_CALLER_ID_NUMBER,
  DYNAMIC_CALLER_ID_NUMBER_DISPLAY,
} from '../constants';

export const PhoneCell: FC<TableCellProps> = customCell((props) => {
  const { dataItem } = props;
  const { number, loading } = dataItem;

  if (loading) {
    return <BodyText size='small'>{number}</BodyText>;
  }
  return (
    <Text size='small'>
      {number === DYNAMIC_CALLER_ID_NUMBER
        ? DYNAMIC_CALLER_ID_NUMBER_DISPLAY
        : maskPhoneNumber(number)}
    </Text>
  );
});
